import { useCallback, useMemo, useState } from 'react';
import { CitationReport, WorkData } from '../types';

const useActiveWork = (report: CitationReport | null) => {
  const [activeWorkId, setActiveWorkId] = useState<string | null>(null);

  // Active work functionality
  const getActiveWork = useCallback(
    (activeWorkId: string, report: CitationReport): WorkData | null => {
      if (!activeWorkId || !report) {
        return null;
      }

      // Search in report references
      const foundInReferences = report.references?.find(
        (workData) => workData.work?.id === activeWorkId,
      );
      if (foundInReferences) {
        return foundInReferences;
      }

      // Search in suggested works from claims
      for (const claim of report.claims || []) {
        if (claim.search?.suggested_works) {
          const foundInSuggested = claim.search.suggested_works.find(
            (workData) => workData.work?.id === activeWorkId,
          );
          if (foundInSuggested) {
            return foundInSuggested;
          }
        }
      }

      return null;
    },
    [],
  );

  const activeWork = useMemo(
    () => (activeWorkId && report ? getActiveWork(activeWorkId, report) : null),
    [activeWorkId, report, getActiveWork],
  );

  return { activeWorkId, setActiveWorkId, activeWork };
};

export default useActiveWork;
